import type { CapBag } from './capBag';
import type { Identity } from './identity';

/**
 * A call identity bundled with its durable capability set. The {@link Identity}
 * is fixed for the life of the principal; the {@link CapBag} is mutable and
 * extensible — caps accumulate as the peer grants them.
 *
 * Transient, per-call (one-shot) grants are deliberately NOT part of a
 * principal: that is a separate policy, see `OneShotCapStaging`.
 *
 * Lives in its own module (rather than alongside `SigningSender`) so the
 * `SigningSender` ⇄ `createManagedPrincipal` factory cycle does not run through
 * a top-level `class … extends Principal`: such a cycle would hit a TDZ
 * ("Class extends value undefined") depending on module evaluation order.
 */
export class Principal {
    constructor(
        public readonly identity: Identity,
        public readonly capBag: CapBag,
    ) { }
}
